import { useParams, useNavigate } from "react-router-dom";
import { getDriverOrderDetails } from "services/driverService";
import { useRTL } from "hooks/isRTL";
import OrdersTabShared from "./OrdersTabShared";

const DriverOrdersDetails = () => {
  const { t } = useRTL();
  const { driverId } = useParams();
  const navigate = useNavigate();

  const columns = [
    { id: "orderNumber", label: t("orderNumber") },
    { id: "senderName", label: t("senderName") },
    { id: "receiverName", label: t("receiverName") },
    { id: "pickUpLocation", label: t("pickUpLocation") },
    { id: "pickupDateTime", label: t("pickupDateTime") },
    { id: "dropOffLocation", label: t("dropOffLocation") },
    { id: "dropOffDateTime", label: t("dropOffDateTime") },
    {
      id: "status",
      label: t("orderStatus"),
      name: "orderStatus",
    },
  ];

  return (
    <OrdersTabShared
      id={driverId}
      fetchFn={getDriverOrderDetails}
      queryKey="driverOrderDetails"
      columns={columns}
      initialStatus={null}
      navigateToOrderDetails={(orderId) => navigate(`/orders/${orderId}`)}
      showEmptyStateMessage={true}
    />
  );
};

export default DriverOrdersDetails;
